export default __webpack_public_path__ + "img/ewfSamkE.5d3a0d8a.svg";